import {FacilityKey} from 'enums';
import {IFacility} from 'types/facility';

export const facilities = [
  {
    key: FacilityKey.CQ,
    name: 'EVOLVE Clarke Quay',
    shortName: 'CQ',
    title: 'Clarke Quay',
    openTime: [6, 30],
    closeTime: [23, 0],
    areas: [
      {
        key: 'CQ_MT',
        name: 'Muay Thai',
        shortName: 'MT',
        background: '#a5a5a5',
        color: '#000',
      },
      {
        key: 'CQ_JJ',
        name: 'BJJ',
        shortName: 'JJ',
        background: '#00b0f0',
        color: '#000',
      },
      {
        key: 'CQ_ZOOM',
        name: 'Zoom',
        shortName: 'Z',
        background: '#00b0f0',
        color: '#000',
        isZoom: true,
      },
    ],
  },
  {
    key: FacilityKey.FES,
    name: 'EVOLVE FES',
    shortName: 'FES',
    title: 'Far East Square',
    openTime: [6, 30],
    closeTime: [23, 15],
    areas: [
      {
        key: 'FES_WARRIOR',
        name: 'Warrior',
        shortName: 'W',
        background: '#a5a5a5',
        color: '#000',
      },
      {
        key: 'FES_CHAMPION',
        name: 'Champion',
        shortName: 'C',
        background: '#00b0f0',
        color: '#000',
      },
      {
        key: 'FES_LEGEND',
        name: 'Legend',
        shortName: 'L',
        background: '#ffd331',
        color: '#000',
      },
      {
        key: 'FES_HIIT_ZONE',
        name: 'HIIT Zone',
        shortName: 'HIIT',
        background: '#555',
        color: '#fff',
        isHIIT: true,
      },
      {
        key: 'FES_ZOOM',
        name: 'Zoom',
        shortName: 'Z',
        background: '#00b0f0',
        color: '#000',
        isZoom: true,
      },
      {
        key: 'FES_RING',
        name: 'Ring',
        shortName: 'R',
        background: '#00b0f0',
        color: '#000',
        isRing: true,
      },
      {
        key: 'FES_CAGE',
        name: 'Cage',
        shortName: 'CG',
        background: '#00b0f0',
        color: '#000',
        isCage: true,
      },
    ],
  },
  {
    key: FacilityKey.OC,
    name: 'EVOLVE OC',
    shortName: 'OC',
    title: 'Orchard Central',
    openTime: [6, 30],
    closeTime: [23, 0],
    areas: [
      {
        key: 'OC_MT',
        name: 'Muay Thai',
        shortName: 'MT',
        background: '#a5a5a5',
        color: '#000',
      },
      {
        key: 'OC_JJ',
        name: 'BJJ',
        shortName: 'JJ',
        background: '#00b0f0',
        color: '#000',
      },
      {
        key: 'OC_ZOOM',
        name: 'Zoom',
        shortName: 'Z',
        background: '#00b0f0',
        color: '#000',
        isZoom: true,
      },
    ],
  },
  {
    key: FacilityKey.KINEX,
    name: 'EVOLVE KINEX',
    shortName: 'KINEX',
    title: 'KINEX',
    openTime: [6, 30],
    closeTime: [23, 30],
    areas: [
      {
        key: 'KINEX_MT',
        name: 'Muay Thai',
        shortName: 'MT',
        background: '#a5a5a5',
        color: '#000',
      },
      {
        key: 'KINEX_JJ',
        name: 'BJJ',
        shortName: 'JJ',
        background: '#00b0f0',
        color: '#000',
      },
      {
        key: 'KINEX_ZOOM',
        name: 'Zoom',
        shortName: 'Z',
        background: '#00b0f0',
        color: '#000',
        isZoom: true,
      },
    ],
  },
  {
    key: FacilityKey.SV,
    name: 'EVOLVE Star Vista',
    shortName: 'SV',
    title: 'Star Vista',
    openTime: [6, 30],
    closeTime: [23, 0],
    areas: [
      {
        key: 'SV_MT',
        name: 'Muay Thai',
        shortName: 'MT',
        background: '#a5a5a5',
        color: '#000',
      },
      {
        key: 'SV_JJ',
        name: 'BJJ',
        shortName: 'JJ',
        background: '#00b0f0',
        color: '#000',
      },
      {
        key: 'SV_ZOOM',
        name: 'Zoom',
        shortName: 'Z',
        background: '#00b0f0',
        color: '#000',
        isZoom: true,
      },
    ],
  },
] as IFacility[];
